import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import RatingStar from 'app/components/SVGS/RatingStar'
import ErrorLabel from 'app/components/ErrorLabel'
import './styles.scss'

const bc = 'rated-start'

const RatedStars = ({ i18n: { language }, valueStars, input, meta: { error, touched, form } }) => {
  const handleOptionChange = event => {
    input.onChange(parseInt(event.target.value))
  }

  return (
    <div
      className={cn(`${bc}__main`, {
        [`${bc}__main__${language}`]: language,
      })}
    >
      <div className={`${bc}__wrapper`}>
        {valueStars.map((val, i) => {
          const id = `rated-star-${val}-${form}`
          return (
            <span key={i}>
              <label className={input.value > i ? `${bc}__star-active` : `${bc}__star`} htmlFor={id}>
                <RatingStar />
              </label>
              <input
                className={`${bc}__input`}
                type="radio"
                id={id}
                value={val}
                checked={input.value === i + 1}
                onChange={handleOptionChange}
              />
            </span>
          )
        })}
      </div>
      {error && touched && <ErrorLabel error={error} />}
    </div>
  )
}

RatedStars.defaultProps = {
  valueStars: [1, 2, 3, 4, 5],
}

RatedStars.propTypes = {
  valueStars: PropTypes.array,
  selectRateStar: PropTypes.func,
  input: PropTypes.object,
}

export default withTranslation()(RatedStars)
